import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import Modal from '../common/modal';
import DeleteForm from '../forms/delete';

const useStyles = makeStyles({
  root: {
    width: '55.3125rem',
  },
  title: {
    fontSize: '2.5rem',
    lineHeight: '2.9375rem',
    marginBottom: '.8125rem',
  },
  body: {
    fontSize: '1.25rem',
    lineHeight: '150%',
    marginBottom: '2.0625rem',
  },
  button: {
    marginTop: '2.875rem',
  },
});

const DeleteModal = ({ open, disabled, onClose, onSubmit }) => {
  const classes = useStyles();
  return (
      <Modal
      className={classes.root}
      open={open}
      disableBackdropClick={false}
      onClose={() => onClose()}
    >
      <Typography className={classes.title} variant="h2" align="center">
        To delete, please enter DELETE below
      </Typography>
      <DeleteForm disabled={disabled} onCancel={onClose} onSubmit={onSubmit} />
    </Modal>
  )
}

export default DeleteModal;